<template>
  <div>
    <onlyoffice-editor
      :src="domain.onlyOfficeSrc"
      :config="editor"
      @ready="onEditorReady"
      class="office-editor"
    />
  </div>
</template>

<script>
import { OnlyofficeEditor } from "onlyoffice-vue";
import GlobalModel from "@/assets/js/config/global";

export default {
  components: { OnlyofficeEditor },
  props: {
    editor: {
      type: Object,
      default: () => {
        editorConfig: {
        }
      }
    }
  },
  data() {
    return { domain: GlobalModel.domain };
  }, // data end
  created() {
    console.log('{ width: "100%", height: "100%" },', this.editor);
  }, // created end
  mounted() {
    console.log("editor", this.editor);
  },
  methods: {
    createEditor() {
      this.editor = new window.DocsAPI.DocEditor("onlyoffice", editorConfig);
    },
    onEditorReady(editor) {
      console.log("editor", editor);
    }
  }
};
</script>

<style scoped lang="less">
.office-editor {
  // width: 60vw;
  // height: 80vh;
}
</style>



// WEBPACK FOOTER //
// components/onlyOffice/index.vue